
import React, { useEffect, useState, useRef } from 'react'
import { InputBox, FormButton, Switch, AutoCompleteBox, AutoCompleteBoxWithLabel, DateBox, MonthBox, YearBox, SelectInputBox } from "../commoncomponents/InputBox";
import { useAuth } from '../../context/auth';
import { Table } from '../commoncomponents/Table';
//loder
import BlurLoader from "../Loder/BlurLoader";
//react toast 
import { toast } from 'react-toastify';
//common Data
import { API_SERVER, handleDownloadExcel, initializeFilterData } from '../../Utils';
//services
import { post } from '../../apiservices/service';
import { getCommonData, getMasterData } from '../../apiservices/CommonServices';
import { Token, currentYear, dateFormate, number, numberwithDot } from '../Common/Common';

function PFReport() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();
    //token Data
    const TokenData = Token();

    //initial state
    const [recipe, setRecipe] = useState({
        branch: '',
        month: '',
        year: '',
    });

    const [loading, setLoading] = useState(false);
    const [branchAllData, setBranchAllData] = useState([]);
    const [companyAllData, setCompanyAllData] = useState([]);
    const [errors, setErrors] = useState({});
    const [yearData, setYearData] = useState([]);
    const [monthData, setMonthData] = useState([]);

    const [result, setResult] = useState({});
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData);
    const [isUpdate, setIsUpdate] = useState(false);
    const [showTable, setShowTable] = useState(false);

    //Get Month Data
    const GetMonthData = () => {
        setMonthData([])
        let temp = {
            Type: "GetMonth",
            Prefix: '',

        }
        setLoading(true)
        getMasterData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setMonthData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setMonthData(data)
                }
            }
        });
    };


    //Get Year Data
    const GetYearData = () => {
        setYearData([])
        let temp = {
            Type: "GetYear",
            Prefix: '',

        }
        setLoading(true)
        getMasterData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setYearData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setYearData(data)
                }
            }
        });
    };

    //Get company Data for AutoComplete
    const GetCompanyData = (value) => {
        setCompanyAllData([])
        let temp = {
            Type: "GetCompany",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        //  setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setCompanyAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setCompanyAllData(data)
                }
            }
        });
    };


    //Get branch Data for AutoComplete
    const GetBranchData = (value) => {
        setBranchAllData([])
        let temp = {
            Type: "GetBranch",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        //   setLoading(true)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setBranchAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setBranchAllData(data)
                }
            }
        });
    };


    //Submit Handler
    const handleSubmit = () => {
        if (Validate()) {
            setLoading(true)
            post(`${API_SERVER}api/Report/PFReport`, { ...TokenData, Type: 'S', PageIndex: '1', ...recipe, branch: user.branch }, (res) => {
                if (res && res.Status) {
                    if (res.Status === "ERROR") {
                        toast.error(res.Message)
                        setLoading(false)
                    } else if (res.Status === "EXPIRED") {
                        toast.error(res.Message)
                        sessionExpired()
                    } else if (res.Status === "UNAUTHORIZED") {
                        toast.error(res.Message);
                        setLoading(false);
                    } else {
                        setShowTable(true)
                        setLoading(false)
                        setResult({ ...res })
                    }
                }
            });
        }
    };



    //Get Table Data
    //const getFormData = (CurrentPage) => {
    //    let PageIndex = 1
    //    if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
    //        PageIndex = CurrentPage;
    //        setCurrentPageNo(CurrentPage);
    //    }
    //    else {
    //        setCurrentPageNo(1);
    //    }

    //    setLoading(true)

    //    let temp = {
    //        PageIndex: PageIndex.toString(),
    //        SearchText: "",
    //        StartValue: "1",
    //        SearchFieldValue: "",
    //        Type: "s"
    //    }
    //    post(`${API_SERVER}api/Report/PFReport`, { ...TokenData, ...temp, ...sortConfig, ...filterData }, (res) => {
    //        if (res && res.Status) {
    //            if (res.Status === "ERROR") {
    //                setLoading(false)
    //                setResult({ ...res })
    //            } else if (res.Status === "EXPIRED") {
    //                toast.error(res.Message)
    //                sessionExpired()
    //            } else if (res.status === "UNAUTHORIZED") {
    //                toast.error(res.message);
    //                setLoading(false);
    //            } else {
    //                setLoading(false)
    //                setResult({ ...res })
    //            }
    //        }
    //    });
    //}


    // change for table
    //const handleChange1 = (event, value) => {
    //    getFormData(value);
    //};

    //useEffect(() => {
    //    getFormData()
    //}, [isUpdate, sortConfig])

    // Sort To ASC and DESC

    //const handleSorting = (SortColumn) => {
    //    let SortOrder = 'ASC';

    //    if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
    //        SortOrder = 'DESC';
    //    }
    //    setSortConfig({ SortColumn, SortOrder });
    //    //getFormData()
    //    handleSubmit()
    //};




    useEffect(() => {
        inputrefs.current['txtMonth'].focus();
        document.title = 'Viva HRMS : PF Report';
        // GetCompanyData();
        GetBranchData();
        GetYearData();
        GetMonthData();
    }, []);


    //Change Handler
    const HandleChange = (prop, value) => {
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    };

    // handle Validate
    const Validate = () => {
        setErrors({})
        let isValid = true;
        let validation = [
            //{ field: "branch", msg: 'Please Enter Branch.' },
            { field: "month", msg: 'Please Enter Month.' },
            { field: "year", msg: 'Please Enter Year.' },
        ]

        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0 || recipe[item.field] === '') {

                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });

        return isValid;
    };



    //Reset Handler
    const handleClear = () => {
        setRecipe(recipe => ({
            ...recipe,
            branch: '',
            month: '',
            year: '',
        }))
        setErrors({})
        setFilterData(filterData => ({ ...filterData, SearchText: '' }))
        setIsUpdate(!isUpdate)
        setShowTable(false)
        setResult({})
        //getFormData()
        // handleSubmit()
    };

    let CompanyData = [];
    for (let i = 0; i < companyAllData.length; i++) {
        let mydata = companyAllData[i]?.values
        CompanyData.push(mydata)
    };

    let BranchData = [];
    for (let i = 0; i < branchAllData.length; i++) {
        let mydata = branchAllData[i]?.values
        BranchData.push(mydata)
    };


    //Start Export functionality
    let ExportRequest = {
        ...TokenData,
        ...recipe,
        Type: 'E',
        PageIndex: '1',
        branch: user.branch
    };
    //End Export functionality


    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">PF Report</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        {/*<AutoCompleteBox*/}
                        {/*    inputrefs={inputrefs}*/}
                        {/*    onKeyDown={(e) => {*/}
                        {/*        if (e.key === 'Enter') { inputrefs.current['txtBranch'].focus() };*/}
                        {/*    }}*/}
                        {/*    id='txtCompany'*/}
                        {/*    label='Company'*/}
                        {/*    placeholder="Company"*/}
                        {/*    maxLength='50'*/}
                        {/*    options={CompanyData}*/}
                        {/*    key='txtCompany'*/}
                        {/*    //  required={true}*/}
                        {/*    //error={errors.company}*/}
                        {/*    inputValue={recipe.company ? recipe.company : ''}*/}
                        {/*    onInputChange={(event, newInputValue) => {*/}
                        {/*        GetCompanyData(newInputValue)*/}
                        {/*        HandleChange('company', newInputValue)*/}

                        {/*    }}*/}
                        {/*/>*/}
                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtMonth'].focus() };
                            }}
                            label='Branch'
                            placeholder="Branch"
                            maxLength='50'
                            options={BranchData}
                            id='txtBranch'
                            key='txtBranch'
                            required={true}
                            disabled
                            error={errors.branch}
                            inputValue={user.branch}
                            onInputChange={(event, newInputValue) => {
                                GetBranchData(newInputValue)
                                HandleChange('branch', newInputValue)

                            }}
                        />

                        <SelectInputBox
                            label='Month'
                            inputrefs={inputrefs}
                            id='txtMonth'
                            value={recipe.month}
                            required
                            error={errors.month}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtYear'].focus() };
                            }}
                            onChange={(e) => HandleChange('month', e.target.value)}
                            children={<>
                                <option value="">--Month--</option>
                                {monthData.map((opt, index) => <option key={index} value={opt.code} >{opt.name}</option>)}
                            </>}
                        />

                        <SelectInputBox
                            label='Year'
                            inputrefs={inputrefs}
                            id="txtYear"
                            value={recipe.year}
                            required
                            error={errors.year}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { handleSubmit() };
                            }}
                            onChange={(e) => HandleChange('year', e.target.value)}
                            children={<>
                                <option value="">--Year--</option>
                                {yearData.map((opt, index) => <option key={index} value={opt.id} >{opt.name}</option>)}
                            </>}
                        />

                        <FormButton
                            saveButtonIcon='fa-search'
                            SaveText='Search'
                            handleSubmit={handleSubmit}
                            handleExport={() => Validate() ? handleDownloadExcel(API_SERVER + 'api/Report/PFReport', ExportRequest, 'PF Report', sessionExpired) : ''}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>


            {/* Table Component start*/}

            {showTable &&
                <Table
                    Filter={false}
                    Action={false}
                    Token={TokenData}
                    PageName='PFReport'
                    tableData={result}
                // handleEdit={handleEdit}
                //  handleDelete={handleDelete}
                //  handleFilter={() => {
                //getFormData();
                //setFilterData({
                //    ...filterData,
                //});

                //  }}
                //  loading={loading}
                // filterData={filterData}
                //  setFilterData={setFilterData}
                //  currentPageNo={currentPageNo}
                //  handleChange1={handleChange1}
                //   handleSorting={handleSorting}
                //  sortConfig={sortConfig}
                />
            }
            {/* Table Component End*/}

            {loading && < BlurLoader />}
        </>
    )
};

export default PFReport
